import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CampanhaFilter } from '../../filter';
import { CampanhaResultado } from '../campanha-resultado';
import { CampanhaLeadViewComponent } from '../../leads/view';
import { CampanhaClienteViewComponent } from '../../clientes/view';
import { CampanhaPedidoViewComponent } from '../../pedidos/view';

@Component({
    selector: 'sgt-campanha-resultado-view',
    templateUrl: './campanha-resultado-view.component.html',
    styleUrls: ['./campanha-resultado-view.component.less']
})
export class CampanhaResultadoViewComponent {
    @Input() idCampanha: number;
    @Input() isStatusEmAnalise: boolean;
    @Input() filter: CampanhaFilter;
    @Input() isLoading: boolean;
    @Input() resultado: CampanhaResultado;
    @Input() isShowAquisicoes = true;

    // Vendas
    isFirtSearchVendas = true;
    @ViewChild('resultadoVendas') resultadoVendas: CampanhaPedidoViewComponent;
    // Leads
    isFirtSearchLeads = true;
    @ViewChild('resultadoLeads') resultadoLeads: CampanhaLeadViewComponent;
    // Clientes
    isFirtSearchClientes = true;
    @ViewChild('resultadoClientes') resultadoClientes: CampanhaClienteViewComponent;

    private resize() {
        jQuery(window).trigger('resize');
    }

    onTabVendasClick() {
       setTimeout(() =>  {
            if (this.isFirtSearchVendas) {
                this.resultadoVendas?.search();
                this.isFirtSearchVendas = false;
            } else {
                this.resize();
            }
       }, 0);
    }

    onTabLeadsClick() {
        if (!this.isShowAquisicoes) {
            return;
        }

        setTimeout(() =>  {
            if (this.isFirtSearchLeads) {
                this.resultadoLeads?.search();
                this.isFirtSearchLeads = false;
            } else {
                this.resize();
            }
        }, 0);
    }

    onTabClientesClick() {
        if (!this.isShowAquisicoes) {
            return;
        }

        setTimeout(() =>  {
            if (this.isFirtSearchClientes) {
                this.resultadoClientes?.search();
                this.isFirtSearchClientes = false;
            } else {
                this.resize();
            }
        }, 0);
    }
}
